import React, { useEffect, useState } from "react";
import {
  Box,
  Container,
  Typography,
  Stack,
  Divider,
  Paper,
  CircularProgress,
} from "@mui/material";
import dayjs from "dayjs";
import api from "../../services/api";

const LegacyOrdersPage = () => {
  const [legacyOrders, setLegacyOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.title = "Legacy Orders";
    fetchLegacyOrders();
  }, []);

  const fetchLegacyOrders = async () => {
    try {
      const res = await api.get("/legacy-orders/my-legacy-orders");
      setLegacyOrders(res.data || []);
    } catch (err) {
      console.error("Failed to fetch legacy orders", err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Box sx={{ py: 8, textAlign: "center" }}>
        <CircularProgress />
        <Typography variant="body1" mt={2}>
          Loading legacy orders...
        </Typography>
      </Box>
    );
  }

  return (
    <Container maxWidth="md" sx={{ py: 6 }}>
      <Typography variant="h4" fontWeight="bold" gutterBottom>
        Legacy Orders ({legacyOrders.length})
      </Typography>

      {legacyOrders.length === 0 ? (
        <Typography>No legacy orders found.</Typography>
      ) : (
        <Stack spacing={4}>
          {legacyOrders.map((order) => (
            <Paper key={order._id} sx={{ p: 3 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Order ID: {order.orderId}
              </Typography>
              <Typography variant="body1" fontWeight={600}>
                {order.customerInfo?.name}
              </Typography>
              <Typography variant="body2">
                Ordered on: {dayjs(order.orderDate).format("MMMM D, YYYY")}
              </Typography>
              <Typography variant="body2">
                Pickup Date:{" "}
                {dayjs(order.collectionDate).format("MMMM D, YYYY")} at{" "}
                {order.collectionTime}
              </Typography>
              <Typography variant="body2">
                Pickup Location: {order.collectionLocation}
              </Typography>

              <Divider sx={{ my: 2 }} />

              {order.products.map((p, i) => (
                <Stack
                  key={i}
                  direction="row"
                  alignItems="center"
                  spacing={2}
                  sx={{ mb: 2 }}>
                  <Box
                    component="img"
                    src={p.imgPath}
                    alt={p.name}
                    sx={{
                      width: 64,
                      height: 64,
                      borderRadius: 1,
                      objectFit: "cover",
                    }}
                  />
                  <Box>
                    <Typography fontWeight={500}>
                      {p.name}
                      {p.flavor ? ` – ${p.flavor}` : ""} × {p.quantity}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      ${p.price.toFixed(2)} each
                    </Typography>
                  </Box>
                </Stack>
              ))}

              <Divider sx={{ my: 2 }} />

              {order.coupon?.applied && (
                <Typography variant="body2" color="green">
                  Coupon Applied: {order.coupon.code} (-$
                  {parseFloat(order.coupon.appliedAmount).toFixed(2)})
                </Typography>
              )}

              <Typography fontWeight={600}>
                Total Paid: ${order.total.toFixed(2)}
              </Typography>

              <a
                href={order.stripeReceiptUrl}
                target="_blank"
                rel="noreferrer"
                style={{
                  fontSize: 14,
                  color: "#1976d2",
                  textDecoration: "underline",
                }}>
                View Receipt
              </a>
            </Paper>
          ))}
        </Stack>
      )}
    </Container>
  );
};

export default LegacyOrdersPage;
